import React, { Component } from "react";
import "./MenuButton.scss";
import { translate } from "clavis-nxt-components-custdevtm";

class MenuButton extends Component {
  changeMenu = () => {
    document
      .getElementById("menu-size-button")
      .dispatchEvent(new CustomEvent("changeMenuSize"));
  };

  render() {
    return (
      <div
        id="menu-size-button"
        className={"open-menu prod-page-header-background-color "}
      >
        <i
          className="icon-openmenu icon-extra-large "
          onClick={() => this.changeMenu()}
        />
      </div>
    );
  }
}

export default translate()(MenuButton);
